import React from "react";
import { Button } from "@material-ui/core";

// styles
import useStyles from "./styles";
import useStylesTwo from "../../../themes/makeStyles";

// components
import { Typography } from "../Wrappers";

export default function PageTitle(props) {
  var classes = useStyles();
  var classesTwo = useStylesTwo();

  return (
    <div >
    
      <h2 className={classes.mainHeading}> {props.title}</h2>
      {props.button && (
        <Button
          classes={{ root: classes.button }}
          variant="contained"
          size="large"
          color="secondary"
        >
          {props.button}
        </Button>
      )}
    </div>
  );
}
